<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          基于经纬度信息的辅助室外巡检导航系统
        </div>
        <div class="txt">
          Aided outdoor inspection navigation system based on latitude and longitude information
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>基于经纬度信息的室外辅助巡检导航系统，由国网上海市电力公司长兴供电公司于2021年4月在指定区域内进行实际的应用试验。
通过经纬度信息，可以实现基于经纬度信息的室外辅助巡检导航功能，提升了供电企业对于室外巡检工作的工作效率，保障了供电企业
的服务质量。通过系统，使用者也可以添加指定的经纬度地点作为导航目的地，系统服务器和程序的功能均经过了实际的应用测试考验。</p>
        </div> 
      </div>
      <div>
        <div class="title">现场图片</div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img51.png" alt="">
            <div class="txt">
              图一：用户注册界面
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/img52.png" alt="">
            <div class="txt">
              图二：用户登陆界面
            </div>
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img53.png" alt="">
            <div class="txt">
              图三：经纬度坐标检索页面，系统提供了查看线路和新增线路两个按钮。查看线路是查看用户选中的经纬度坐标的导航线路。新增线路则是用于管理用户新增经纬度坐标点到经纬度坐标数据库。
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/img54.png" alt="">
            <div class="txt">
              图四：起始位置选定页面，系统用户点击查看按钮之后跳转到起始位置选定界面，默认是用户当前位置的经纬度位置，系统用户也可以自定义起始位置。自定义起始位置的导航线路更加准确。自定义起始位置是用户可以手动输入理想的起始位置的地理位置信息。
            </div>
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img55.png" alt="">
            <div class="txt">
              图五：导航服务页面，导航服务页面在地图上标识规划好的路径，同时提示距离目的地的总路程。同时，还提供详细的路径解释说明内容。
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/img56.png" alt="">
            <div class="txt">
              图六：导航服务页面
            </div>
          </div>
        </div> 
        
      </div>
    </div>

    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 300px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one img {
  width: 450px;
  height: 510px;
}
.img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 20px;
  font-size: 13px;
}


.detail_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail4.vue